<template>
  <v-container class="py-0 pl-0 pr-0">
    <v-row dense row wrap>
      <v-col class="col-12">
        <div style="text-align: center;">
          <v-btn
            block
            text
            x-small
            color="primary"
            class="all_button mb-3"
            :disabled="loadingAllNone"
            @click="handleEnableDisableAllFilters"
            >{{
              allMapped
                ? "Disable All Risk Type Filters"
                : "Enable All Risk Type Filters"
            }}
            <v-progress-circular
              v-if="loadingAllNone"
              indeterminate
              color="#a5a5a5"
              size="12"
              width="1"
              class="ml-2"
            ></v-progress-circular>
          </v-btn>
        </div>
        <RiskCategoryPicker
          v-for="riskCategory in riskCategories"
          :riskCategory="riskCategory"
          :selected-risk-categories="selectedRiskCategories"
          :key="riskCategory.id"
          :reset="reset"
          :risk-categories-filter-counts="riskCategoriesFilterCounts"
          :expanded="expanded.includes(riskCategory.id)"
          :map-all="mapAll"
          @changed="handleChange"
          @expanded="handleExpanded"
        ></RiskCategoryPicker>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";
import lodashRemove from "lodash/remove";
import lodashDebounce from "lodash/debounce";

import { getRiskCategoriesByGroup } from "@/services/controlRisks/risks.service";

const EMITTED_ACTIONS = {
  CHANGE: "change",
  CHANGE_HAS_RISK_TYPES_SELECTED: "change-has-risk-types-selected",
};

export default {
  name: "RiskCategoriesPicker",
  components: {
    RiskCategoryPicker: () =>
      import("@/components/riskCategories/RiskCategoryPicker"),
  },
  props: {
    selectedRiskCategories: {
      type: String,
    },
    riskCategoriesFilterCounts: {
      type: Object,
    },
    reset: {
      type: String,
    },
  },
  data: () => ({
    riskCategories: [],
    selection: null,
    expanded: [],
    mapAll: null,
    loadingAllNone: false,
  }),
  mounted() {
    this.initialize();
  },
  computed: {
    allMapped() {
      let isOneMapped = false;
      if (this.riskCategories) {
        for (let i = 0; i < this.riskCategories.length; i++) {
          if (
            this.riskCategories[i].subtopics &&
            this.riskCategories[i].subtopics.length
          ) {
            for (let j = 0; j < this.riskCategories[i].subtopics.length; j++) {
              if (
                this.selectedRiskCategories &&
                (this.selectedRiskCategories.indexOf(
                  this.riskCategories[i].id
                ) > -1 ||
                  this.selectedRiskCategories.indexOf(
                    this.riskCategories[i].subtopics[j].id
                  ) > -1)
              ) {
                isOneMapped = true;
                break;
              }
            }
          } else {
            if (
              this.selectedRiskCategories &&
              this.selectedRiskCategories.indexOf(this.riskCategories[i].id) >
                -1
            ) {
              isOneMapped = true;
              break;
            }
          }
        }
      }
      return isOneMapped;
    },
  },
  methods: {
    initialize() {
      let categories = [];
      const primaryRiskCategories = getRiskCategoriesByGroup({ ui: true });
      const sortedRiskCategories = lodashOrderBy(
        primaryRiskCategories,
        ["order"],
        ["asc"]
      );
      sortedRiskCategories.forEach((riskCategory) => {
        if (this.featureUnlocked(`risk-category-${riskCategory.name}`)) {
          categories.push(riskCategory);
        }
      });
      this.riskCategories = categories;
    },
    handleEnableDisableAllFilters() {
      this.loadingAllNone = true;
      lodashDebounce(() => {
        this.mapAll = {
          enabled: !this.allMapped,
          date: new Date().toISOString(),
        };
      }, 500)();
    },
    handleExpanded(item) {
      if (item.expanded) {
        this.expanded.push(item.riskCategory);
      } else {
        this.expanded = lodashRemove(this.expanded, (check) => {
          return check !== item.riskCategory;
        });
      }
    },
    handleChange(item) {
      this.$emit(EMITTED_ACTIONS.CHANGE, {
        riskCategories: item.selectedRiskCategories,
      });
    },
  },
  watch: {
    selectedRiskCategories: {
      handler() {
        if (this.loadingAllNone) {
          if (this.allMapped) {
            const _riskCategories = this.selectedRiskCategories.split(",");
            if (
              _riskCategories &&
              _riskCategories.length >= this.riskCategories.length
            ) {
              this.loadingAllNone = false;
            }
          } else {
            if (!this.selectedRiskCategories) {
              this.loadingAllNone = false;
            }
          }
        }
        this.initialize();
      },
    },
  },
};
</script>

<style scoped>
.all_button {
  font-size: 14px;
}
</style>
